import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { InfoToast } from '.';

export const useInfoToastEffect = (message: string, trigger: any) => {
  useEffect(() => {
    let toastId: string;
    if (trigger) {
      toastId = toast.custom(p => <InfoToast {...p} message={message} />, {
        duration: 3000,
        removeDelay: 0
      });
    }

    return () => {
      if (toastId) toast.remove(toastId);
    };
  }, [trigger]);
};

export const useInfoToast = () => {
  return (message: string) => {
    toast.custom(p => <InfoToast {...p} message={message} />, {
      duration: 3000,
      removeDelay: 0
    });
  };
};
